// Mock data for Domus Living website

export const projects = [
  {
    id: 1,
    name: "Coastal Residence",
    location: "Brighton, Melbourne",
    image: "https://images.unsplash.com/photo-1602128110234-2d11c0aaadfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2NzE2NDI2MXww&ixlib=rb-4.1.0&q=85",
    year: "2024",
    description: "A contemporary beachside home that seamlessly blends indoor and outdoor living, featuring floor-to-ceiling windows and natural materials.",
    fullDescription: "This stunning coastal residence in Brighton represents the perfect harmony between modern architecture and natural surroundings. The design embraces the beachside location with floor-to-ceiling windows that flood the interior with natural light while framing panoramic ocean views. The material palette features natural timbers, stone, and glass, creating a seamless connection between indoor and outdoor living spaces. The open-plan living areas flow effortlessly onto expansive terraces, perfect for entertaining or quiet contemplation of the sea.",
    galleryImages: [
      "https://images.unsplash.com/photo-1602128110234-2d11c0aaadfe?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 2,
    name: "Urban Sanctuary",
    location: "South Yarra, Melbourne",
    image: "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2NzE2NDI2MXww&ixlib=rb-4.1.0&q=85",
    year: "2024",
    description: "An inner-city retreat designed to maximise natural light and create a sense of calm amidst the urban environment.",
    fullDescription: "Urban Sanctuary is an inner-city retreat that proves tranquility can exist even in the heart of Melbourne. Through careful orientation and clever design, this home maximises natural light while maintaining complete privacy from neighbouring properties. The central courtyard acts as the heart of the home, bringing light and greenery into every room. Clean lines and a restrained material palette create a sense of calm, while thoughtful details add warmth and character throughout.",
    galleryImages: [
      "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 3,
    name: "Garden House",
    location: "Fitzroy, Melbourne",
    image: "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2NzE2NDI2MXww&ixlib=rb-4.1.0&q=85",
    year: "2023",
    description: "A heritage home renovation that celebrates the connection between architecture and landscape through a central courtyard garden.",
    fullDescription: "This heritage renovation in Fitzroy breathes new life into a Victorian-era terrace while respecting its historic character. The design centres around a stunning courtyard garden that brings nature into the heart of the home. Original features have been carefully restored at the front, while a contemporary extension at the rear provides modern living spaces that connect seamlessly with the garden. The result is a home that honours its past while embracing contemporary family life.",
    galleryImages: [
      "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 4,
    name: "Skyline Pavilion",
    location: "Richmond, Melbourne",
    image: "https://images.unsplash.com/photo-1534094830444-3a1e21f7e3e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2NzE2NDI2MXww&ixlib=rb-4.1.0&q=85",
    year: "2023",
    description: "A striking rooftop addition that provides panoramic city views while maintaining privacy from neighbouring properties.",
    fullDescription: "Skyline Pavilion is a bold rooftop addition that transforms a modest Richmond terrace into a spectacular city dwelling. The new upper level is conceived as a glass pavilion, offering 360-degree views of Melbourne's skyline. Strategic screening ensures privacy while allowing uninterrupted views of the city. The design creates a dramatic contrast between the solid masonry of the original building and the lightweight transparency of the addition above.",
    galleryImages: [
      "https://images.unsplash.com/photo-1534094830444-3a1e21f7e3e7?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566752547-33b9d5c7c8e8?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 5,
    name: "Modern Villa",
    location: "Toorak, Melbourne",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZXxlbnwwfHx8fDE3NjcxNjQyNzN8MA&ixlib=rb-4.1.0&q=85",
    year: "2023",
    description: "A luxurious family home featuring clean lines, expansive living spaces, and a seamless indoor-outdoor flow.",
    fullDescription: "This luxurious Toorak villa represents the pinnacle of contemporary residential design. Clean architectural lines frame expansive living spaces that flow seamlessly between interior and exterior. The home is designed around a central swimming pool and garden, creating a resort-like atmosphere. Premium materials including natural stone, timber, and bronze detailing create an atmosphere of understated luxury throughout.",
    galleryImages: [
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 6,
    name: "Bayside Home",
    location: "St Kilda, Melbourne",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZXxlbnwwfHx8fDE3NjcxNjQyNzN8MA&ixlib=rb-4.1.0&q=85",
    year: "2022",
    description: "A coastal-inspired residence that captures bay views and ocean breezes through thoughtful orientation and design.",
    fullDescription: "Bayside Home captures the essence of coastal living in St Kilda. Every room is oriented to maximise views of Port Phillip Bay while inviting cooling sea breezes throughout the home. The design features a palette of natural materials that will weather gracefully in the marine environment. Expansive decks and terraces extend the living spaces outdoors, creating the perfect setting for relaxed coastal living.",
    galleryImages: [
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 7,
    name: "Contemporary Estate",
    location: "Hawthorn, Melbourne",
    image: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob3VzZXxlbnwwfHx8fDE3NjcxNjQyNzN8MA&ixlib=rb-4.1.0&q=85",
    year: "2022",
    description: "A grand family estate that balances traditional elegance with modern functionality across multiple living zones.",
    fullDescription: "This grand Hawthorn estate masterfully balances traditional elegance with contemporary functionality. The design creates distinct zones for formal entertaining, casual family living, and private retreat, all connected by generous circulation spaces. Traditional detailing is reinterpreted through a contemporary lens, creating interiors that feel both timeless and fresh. Extensive gardens surround the home, providing privacy and a beautiful backdrop to daily life.",
    galleryImages: [
      "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 8,
    name: "Waterfront Residence",
    location: "Port Melbourne, Melbourne",
    image: "https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg",
    year: "2022",
    description: "A waterfront home designed to maximise harbour views while providing intimate family spaces and entertainment areas.",
    fullDescription: "Waterfront Residence takes full advantage of its spectacular Port Melbourne location. The design maximises harbour views from every major living space while creating intimate family areas and generous entertaining zones. Floor-to-ceiling glass captures the ever-changing waterfront scenery, while carefully positioned solid walls provide privacy and define interior spaces. A rooftop terrace offers 360-degree views of the city and bay.",
    galleryImages: [
      "https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566752547-33b9d5c7c8e8?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 9,
    name: "Hillside Retreat",
    location: "Kew, Melbourne",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2024",
    description: "A multi-level home built into the hillside, offering sweeping views and private outdoor terraces on every level.",
    fullDescription: "Hillside Retreat is a masterpiece of site-responsive design. Built into the natural slope of the land, each level of the home offers its own private outdoor terrace with sweeping views across the Yarra Valley. The architecture works with the terrain rather than against it, creating a home that feels grounded and connected to its surroundings.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 10,
    name: "Courtyard Villa",
    location: "Prahran, Melbourne",
    image: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2024",
    description: "An urban villa designed around a central courtyard that brings light and nature into every room.",
    fullDescription: "Courtyard Villa reimagines urban living with a design centred on a lush central garden. Every room in the house looks onto this private oasis, creating a sense of connection to nature despite the inner-city location. The courtyard provides natural ventilation and daylighting while offering complete privacy from neighbours.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 11,
    name: "Glass Pavilion",
    location: "Camberwell, Melbourne",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2023",
    description: "A transparent living pavilion that dissolves the boundary between inside and outside.",
    fullDescription: "Glass Pavilion pushes the boundaries of residential architecture with its remarkably transparent design. Floor-to-ceiling glass on all sides creates an extraordinary connection with the surrounding garden, making the interior feel as though it floats within the landscape. Advanced glazing technology ensures comfort year-round despite the openness.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 12,
    name: "Timber House",
    location: "Carlton, Melbourne",
    image: "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2023",
    description: "A warm, sustainable home clad entirely in responsibly sourced Australian hardwood.",
    fullDescription: "Timber House celebrates the beauty of natural materials with a facade entirely clad in responsibly sourced Australian hardwood. The timber will silver gracefully over time, creating a living surface that evolves with the seasons. Inside, the warmth of natural timber continues throughout, creating spaces that feel welcoming and grounded.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 13,
    name: "Concrete Cube",
    location: "Abbotsford, Melbourne",
    image: "https://customer-assets.emergentagent.com/job_arch-design-hub-5/artifacts/hndusukm_Prospect-cover-01.jpg",
    year: "2022",
    description: "A bold architectural statement featuring raw concrete and industrial materials in a refined residential context.",
    fullDescription: "Concrete Cube is an uncompromising expression of material honesty. The exterior presents as a sculptural concrete form, its raw surface animated by the patterns of the formwork. Inside, the brutalist aesthetic is tempered by warm timber floors and carefully positioned openings that frame views of the city skyline.",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_arch-design-hub-5/artifacts/hndusukm_Prospect-cover-01.jpg",
      "https://images.unsplash.com/photo-1600566752547-33b9d5c7c8e8?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 14,
    name: "Laneway House",
    location: "Collingwood, Melbourne",
    image: "https://customer-assets.emergentagent.com/job_arch-design-hub-5/artifacts/gvsuhpmj_Buttrick_PaloAlto-37.jpg",
    year: "2022",
    description: "A compact, cleverly designed home that maximises every square metre of a narrow laneway site.",
    fullDescription: "Laneway House demonstrates that great architecture isn't about size. This compact home makes the most of a challenging narrow site through clever planning and innovative spatial solutions. A central light well brings sun deep into the floor plan, while a rooftop garden provides outdoor living space where ground-level area is limited.",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_arch-design-hub-5/artifacts/gvsuhpmj_Buttrick_PaloAlto-37.jpg",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 15,
    name: "Garden Studio",
    location: "Brunswick, Melbourne",
    image: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2024",
    description: "A backyard studio that serves as a home office, guest suite, and creative retreat.",
    fullDescription: "Garden Studio is the perfect backyard addition for the modern work-from-home lifestyle. This compact structure provides a dedicated workspace just steps from the main house, with the flexibility to serve as guest accommodation or an artist's studio. Large sliding doors open to a private garden, blurring the line between working and living.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 16,
    name: "Pool House",
    location: "Elwood, Melbourne",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2024",
    description: "A poolside pavilion designed for relaxation and entertaining, featuring indoor-outdoor living at its finest.",
    fullDescription: "Pool House creates a resort-like atmosphere in a suburban backyard. This open-air pavilion wraps around a stunning infinity pool, providing shaded lounging areas, an outdoor kitchen, and a cabana for changing. The design celebrates the Australian love of outdoor living with architecture that's as beautiful as it is functional.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 17,
    name: "Rooftop Penthouse",
    location: "Docklands, Melbourne",
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2023",
    description: "A luxury penthouse with 360-degree city views and a private rooftop terrace.",
    fullDescription: "Rooftop Penthouse occupies the top two floors of a new Docklands tower, offering unparalleled views of Melbourne's skyline. The interior design complements the architectural shell with bespoke joinery and premium finishes throughout. A private rooftop terrace provides an outdoor entertaining space suspended above the city.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 18,
    name: "Stone Cottage",
    location: "Eltham, Melbourne",
    image: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2023",
    description: "A modern interpretation of the classic Australian mud brick home, featuring local stone and sustainable design.",
    fullDescription: "Stone Cottage draws inspiration from the Eltham tradition of earthy, hand-crafted homes. Local stone forms the primary building material, creating walls with incredible thermal mass that keep the interior cool in summer and warm in winter. The result is a home that feels ancient yet thoroughly modern.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 19,
    name: "Warehouse Conversion",
    location: "Cremorne, Melbourne",
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2022",
    description: "A heritage warehouse transformed into a spectacular family home while preserving its industrial character.",
    fullDescription: "Warehouse Conversion breathes new life into a heritage-listed wool store, transforming the industrial shell into a spectacular family residence. Original features including exposed brick walls, timber trusses, and steel columns have been carefully preserved and celebrated. New insertions are clearly contemporary, creating a dialogue between old and new.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 20,
    name: "Terrace Renewal",
    location: "Albert Park, Melbourne",
    image: "https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2022",
    description: "A Victorian terrace sensitively extended and updated for contemporary family living.",
    fullDescription: "Terrace Renewal demonstrates how heritage homes can be adapted for modern life without losing their historic charm. The original Victorian rooms at the front have been meticulously restored, while a contemporary extension at the rear provides open-plan living spaces and a connection to a landscaped garden. The result is the best of both worlds.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 21,
    name: "Beach Box",
    location: "Mornington, Melbourne",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2024",
    description: "A compact weekend retreat designed for low-maintenance coastal living.",
    fullDescription: "Beach Box is the ultimate weekend escape on the Mornington Peninsula. This compact home packs everything needed for coastal living into an efficient footprint, with clever storage solutions and multi-purpose spaces. Hardy materials require minimal maintenance, leaving more time for beach walks and relaxation.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1602128110234-2d11c0aaadfe?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 22,
    name: "Forest Lodge",
    location: "Warburton, Melbourne",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2023",
    description: "A nature retreat nestled among towering eucalypts in the Yarra Ranges.",
    fullDescription: "Forest Lodge is a sanctuary among the trees. Set on a secluded bushland block, this retreat offers complete immersion in nature while providing all the comforts of home. Large windows frame views of the surrounding forest, while a wraparound deck provides outdoor living space in the canopy.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 23,
    name: "City Apartment",
    location: "CBD, Melbourne",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2024",
    description: "A sophisticated city apartment designed for urban professionals who appreciate refined living.",
    fullDescription: "City Apartment demonstrates that apartment living can be as refined as any house. This high-rise residence features a carefully considered layout that maximises natural light and city views. Custom joinery provides abundant storage while maintaining clean, uncluttered lines throughout the interior.",
    galleryImages: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  },
  {
    id: 24,
    name: "Heritage Restoration",
    location: "East Melbourne, Melbourne",
    image: "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&w=800",
    year: "2023",
    description: "A meticulous restoration of a grand Victorian mansion to its original splendour.",
    fullDescription: "Heritage Restoration is a labour of love, returning a grand East Melbourne mansion to its original glory. Every historic detail has been carefully researched and authentically restored, from ornate ceiling roses to original fireplaces. Modern services have been discreetly integrated to provide contemporary comfort without compromising heritage character.",
    galleryImages: [
      "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&w=800",
      "https://images.unsplash.com/photo-1534094830444-3a1e21f7e3e7?crop=entropy&cs=srgb&fm=jpg&w=800"
    ]
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Coastal Residence",
    category: "Brighton",
    image: "https://images.unsplash.com/photo-1602128110234-2d11c0aaadfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2NzE2NDI2MXww&ixlib=rb-4.1.0&q=85",
    gallery: ["https://images.unsplash.com/photo-1602128110234-2d11c0aaadfe?crop=entropy&cs=srgb&fm=jpg&w=800", "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 2,
    title: "Urban Sanctuary",
    category: "South Yarra",
    image: "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2NzE2NDI2MXww&ixlib=rb-4.1.0&q=85",
    gallery: ["https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&w=800", "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 3,
    title: "Garden House",
    category: "Fitzroy",
    image: "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2NzE2NDI2MXww&ixlib=rb-4.1.0&q=85",
    gallery: ["https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&w=800", "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 4,
    title: "Skyline Pavilion",
    category: "Richmond",
    image: "https://images.unsplash.com/photo-1534094830444-3a1e21f7e3e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc2NzE2NDI2MXww&ixlib=rb-4.1.0&q=85",
    gallery: ["https://images.unsplash.com/photo-1534094830444-3a1e21f7e3e7?crop=entropy&cs=srgb&fm=jpg&w=800", "https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 5,
    title: "Modern Villa",
    category: "Toorak",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZXxlbnwwfHx8fDE3NjcxNjQyNzN8MA&ixlib=rb-4.1.0&q=85",
    gallery: ["https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&w=800", "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 6,
    title: "Bayside Home",
    category: "St Kilda",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZXxlbnwwfHx8fDE3NjcxNjQyNzN8MA&ixlib=rb-4.1.0&q=85",
    gallery: ["https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&w=800", "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 7,
    title: "Contemporary Estate",
    category: "Hawthorn",
    image: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 8,
    title: "Waterfront Residence",
    category: "Port Melbourne",
    image: "https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg",
    gallery: ["https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg"]
  },
  {
    id: 9,
    title: "Hillside Retreat",
    category: "Kew",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 10,
    title: "Courtyard Villa",
    category: "Prahran",
    image: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 11,
    title: "Glass Pavilion",
    category: "Camberwell",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 12,
    title: "Timber House",
    category: "Carlton",
    image: "https://images.unsplash.com/photo-1600573472592-401b489a3cdc?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600573472592-401b489a3cdc?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 13,
    title: "Concrete Cube",
    category: "Abbotsford",
    image: "https://customer-assets.emergentagent.com/job_arch-design-hub-5/artifacts/hndusukm_Prospect-cover-01.jpg",
    gallery: ["https://customer-assets.emergentagent.com/job_arch-design-hub-5/artifacts/hndusukm_Prospect-cover-01.jpg"]
  },
  {
    id: 14,
    title: "Laneway House",
    category: "Collingwood",
    image: "https://customer-assets.emergentagent.com/job_arch-design-hub-5/artifacts/gvsuhpmj_Buttrick_PaloAlto-37.jpg",
    gallery: ["https://customer-assets.emergentagent.com/job_arch-design-hub-5/artifacts/gvsuhpmj_Buttrick_PaloAlto-37.jpg"]
  },
  {
    id: 15,
    title: "Garden Studio",
    category: "Brunswick",
    image: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 16,
    title: "Pool House",
    category: "Elwood",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 17,
    title: "Rooftop Penthouse",
    category: "Docklands",
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 18,
    title: "Stone Cottage",
    category: "Eltham",
    image: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 19,
    title: "Warehouse Conversion",
    category: "Cremorne",
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 20,
    title: "Terrace Renewal",
    category: "Albert Park",
    image: "https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600566752355-35792bedcfea?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 21,
    title: "Beach Box",
    category: "Mornington",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 22,
    title: "Forest Lodge",
    category: "Warburton",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 23,
    title: "City Apartment",
    category: "CBD",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&w=800"]
  },
  {
    id: 24,
    title: "Heritage Restoration",
    category: "East Melbourne",
    image: "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&w=800",
    gallery: ["https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&w=800"]
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Robert Caccamo",
    role: "Manager",
    phone: "0417 012 601",
    email: "robertprc@bigpond.com",
    description: "I hold a Bachelor of Civil Engineering and an Advanced Diploma of Building Design (Architectural), with over 20 years' experience in residential architectural design. My approach combines technical knowledge with practical building experience to deliver designs that are functional, buildable, and well-resolved.\n\nI'm passionate about thoughtful, well-executed architecture and ensuring every project is delivered to a consistently high standard."
  },
  {
    id: 2,
    name: "Domenic Caccamo",
    role: "Architectural Designer",
    phone: "0406 636 533",
    email: "domenic@domusliving.net",
    description: "I hold a Bachelor of Design (Architecture) and Bachelor of Construction Management, with over three years' experience working in architectural design. I enjoy developing thoughtful design ideas that balance modern architecture with traditional influences, creating spaces that feel contemporary and timeless.\n\nI'm driven by a genuine passion for design and a strong focus on delivering well-considered outcomes."
  }
];

export const studioPhilosophy = "At Domus Living, we believe in creating spaces that enhance daily life through thoughtful design. Our approach is rooted in understanding our clients' needs, respecting the context of each site, and crafting homes that stand the test of time. We focus on materiality, light, and the relationship between interior and exterior spaces to create residences that feel both contemporary and timeless.";
